import React from "react";
import PropTypes from "prop-types";
import { Clock, LocalDateTime, ChronoUnit } from "js-joda";

import { localDateTimeFromApi } from "../utils/dateTime";
import { createRedToGreenColor } from "../utils/colorUtils";

class DurationProgress extends React.Component {
  static calculatePct(value, max) {
    return value / max * 100;
  }

  render() {
    const { trade, closedTrade, config } = this.props;

    const forceSellMins = config.forceSellAfterMinutes;
    const openDate = localDateTimeFromApi(trade.pendingOpenDate);
    const intervalEnd =
      trade.state === "CLOSED" && closedTrade.closeDate
        ? localDateTimeFromApi(closedTrade.closeDate)
        : LocalDateTime.now(Clock.systemUTC());

    let minutesFromOpen = openDate.until(intervalEnd, ChronoUnit.MINUTES);

    const perc = Math.min(100, DurationProgress.calculatePct(minutesFromOpen, forceSellMins));

    const rightGradientColor = createRedToGreenColor(100.0 - perc);

    const gradientColor = `linear-gradient(to right, rgb(50, 205, 50) , ${rightGradientColor})`;

    const style = this.props.style
      ? {
          ...this.props.style,
          width: perc + "%",
          backgroundImage: gradientColor,
        }
      : { width: "100%" };

    return <div className="DurationProgress" style={style} />;
  }
}

DurationProgress.propTypes = {
  config: PropTypes.object.isRequired,
  trade: PropTypes.object.isRequired,
  closedTrade: PropTypes.object,
  style: PropTypes.object,
};

export default DurationProgress;



// WEBPACK FOOTER //
// ./src/components/DurationProgress.js